<template>
  <div class="keyong">
    <!-- 可加项列表 -->
    <div class="top">
      <Select v-model="model1" class="select" @on-change="getSelect" label-in-value>
        <Option v-for="(item, index) in typeList" :value="item.id" :key="index">{{ item.classifyName }}</Option>
      </Select>
      <Input
        placeholder="搜索"
        @on-clear="selectUploadedFeeItemList(1)"
        @on-enter="selectUploadedFeeItemList(1)"
        v-model="name"
        class="journal-input"
        clearable
      >
        <Icon type="ios-search" slot="prefix" />
      </Input>
      <Button class="title-btn fourSize" type="success" @click="tonewAdd" ghost
        >新增</Button
      >
    </div>
    <div class="table-cont">
      <Table
        @on-selection-change="selectChange"
        @on-sort-change="changesort"
        stripe
        :columns="columns"
        :data="data"
      ></Table>
    </div>
    <div class="page-div">
      <div class="page-div-left">
        <div class="left">
          已选 <span>{{ selectNum }}</span> 条
        </div>
        <Button class="title-btn fourSize" type="success" ghost @click="tongbu"
          >同步加项</Button
        >
        <Button class="title-btn fourSize" type="success" ghost @click="piliang"
          >批量修改</Button
        >
      </div>

      <Page
        :total="obj.total"
        @on-page-size-change="changepeoplepage"
        @on-change="changePeoplecurrent"
        show-elevator
        show-total
        :current="current"
        :page-size="pageSize"
        show-sizer
        class="page-div-page"
      />
    </div>

    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success"
      >操作成功</Alert
    >
    <Alert
      class="alertTitle"
      v-show="alertTitleIshow2"
      type="error"
      show-icon
      >{{ alertTitle }}</Alert
    >

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
    <!-- 新增 -->
    <Modal
      class="ivumodal"
      footer-hide
      width="800"
      v-model="addShow"
      title="新增项目"
    >
      <Canadd ref="Canadd" @postSelectd="getSelectd"></Canadd>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="clear(1)">取消</Button>
        <Button class="btn sure" type="success" ghost @click="clear(2)"
          >确定</Button
        >
      </div>
    </Modal>
    <!-- 修改 -->
    <Modal
      class="ivumodal"
      footer-hide
      width="500"
      v-model="modify"
      title="修改"
    >
      <Form ref="xiugai" :model="xiugai" :rules="xiugaidata" :label-width="170">
        <FormItem label="操作条数：" prop="num" class="bumenModal-item">
          <div>
            <span>{{ selectedNum }} </span> 条
          </div>
        </FormItem>
        <FormItem label="可用状态：" prop="select" class="bumenModal-item">
          <RadioGroup v-model="xiugai.select">
            <Radio label="1">
              <span>启用</span>
            </Radio>
            <Radio label="0" style="margin-left:50px;">
              <span>停用</span>
            </Radio>
          </RadioGroup>
        </FormItem>
       <!-- <FormItem label="特殊项目：" prop="special" class="bumenModal-item">
          <RadioGroup v-model="xiugai.special">
            <Radio label="1">
              <span>男</span>
            </Radio>
            <Radio label="2" style="margin-left:50px;">
              <span>女</span>
            </Radio>
            <Radio label="3" style="margin-left:50px;">
              <span>男/女</span>
            </Radio>
          </RadioGroup>
        </FormItem>
          @on-change="changeCheck(item,index)" -->
      </Form>
      <div class="secondBumen-bottom">
       <!-- <Button class="btn" type="success" ghost @click="clearSpecial()">清空</Button>-->
        <Button class="btn" type="success" ghost @click="clear(1)">取消</Button>
        <Button class="btn sure" type="success" ghost @click="clear(3)"
          >确定</Button
        >
      </div>
    </Modal>
    <!--  -->
    <Modal
      class="ivumodal"
      width="500"
      footer-hide
      v-model="errors"
      title="提示"
    >
      <div class="ivumodal-cont">
        请选择套餐
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="ok(2)">取消</Button>
        <Button class="btn sure" type="success" ghost @click="ok(2)"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
    import {
        formatMoney,
        selectUploadedFeeItemList,
        updateFeeItemCanState,
        addFeeItem,
        synFeeItem
    } from "../servers/api";
    import Canadd from "../tan/canadd";
    import {
        parse
    } from "path";
    import {
        type
    } from "os";
    export default {
        name: "canxiang",
        data() {
            return {
                typeList:[],
                model1: -1,
                isiconfontshow: false,
                alertTitleIshow: false,
                alertTitleIshow2: false,
                alertTitle: "",
                errors: false,
                name: "",
                current: 1,
                orderField: "",
                isAsc: "",
                selectedNum: 1,
                pageSize: 20,
                data: [],
                columns: [{
                    type: "selection",
                    width: 60,
                    align: "center"
                        // "fixed": "left",
                }, {
                    title: "项目名称",
                    // width: 150,
                    align: "center",
                    key: "examFeeItemName",
                    ellipsis: true,
                    sortable: true
                }, {
                    title: "项目金额",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "unitPrice",
                    render: (h, params) => {
                        let a = "￥" + formatMoney(params.row.unitPrice);
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        height: "25px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        "line-height": "30px",
                                        color: "#7F7F7F"
                                    }
                                },
                                a
                            )
                        ]);
                    }
                }, {
                    title: "性别",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    width: 100,
                    key: "useSex"
                }, {
                    title: "批准可加日期",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "canAddDate"
                }, {
                    title: "停加日期",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "stopAddDate"
                }, {
                    title: "可加状态",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    width: 120,
                    key: "canAddState",
                    render: (h, params) => {
                        let name = "";
                        if (params.row.canAddState == 0) {
                            name = "停用";
                        } else if (params.row.canAddState == 1) {
                            name = "启用";
                        }
                        return h("div", {}, name);
                    }
                },
                //{
                 //   title: "特殊项目",
                //    align: "center",
                ///    ellipsis: true,
                 //   sortable: true,
                 //   width: 120,
                 //   key: "specialItem",
                 //   render: (h, params) => {
                 //       let name = "";
                 //       if (params.row.specialItem == 1) {
                 //           name = "男";
                 //       } else if (params.row.specialItem == 2) {
                 //           name = "女";
                  //      }else if (params.row.specialItem == 3){
                  //          name = "男/女"
                //       }
                //        return h("div", {}, name);
                //    }
               // }, 
                {
                    title: "操作",
                    key: "awssd",
                    align: "center",
                    width: 110,
                    // "fixed": "right",
                    render: (h, params) => {
                        return h(
                            "div", {
                                style: {
                                    // width:'50px',
                                    height: "30px",
                                    "line-height": "30px",
                                    "text-align": "center",
                                    "font-size": "13px",
                                    background: "#fff",
                                    border: "1px solid #53CAC3",
                                    "border-radius": "5px",
                                    width: "50px",
                                    "margin-left": "12px",
                                    cursor: "pointer"
                                },
                                on: {
                                    click: () => {
                                        this.chengeTable(params.row);
                                    }
                                }
                            },
                            "修改"
                        );
                    }
                }],
                selectNum: 0, //已选数量
                selectList: [],
                addShow: false,
                modify: false, //修改
                xiugai: {
                    num: "",
                    select: "1",
                    special: ""
                },
                xiugaidata: {
                    select: [{
                        required: true,
                        message: "请选择可用状态",
                        trigger: "blur"
                    }]
                },
                list: [],
                obj: {},
                addSelectd: []
            };
        },
        methods: {
            clearSpecial(){
                this.xiugai.special = '',
                this.xiugai.select = ''
            },
            getSelect(name) {
      //     console.log(name,'this.model1')
       //     this.selectUploadedBasExamSuiteList()
          },
            tongbu() {
                //同步
                if (this.selectNum > 0) {
                    this.isiconfontshow = true;
                    let list = [];
                    for (let i = 0; i < this.selectList.length; i++) {
                        list.push(this.selectList[i].id);
                    }
                    let params = {
                        idList: list.join(",")
                    };
                    synFeeItem(params).then(res => {
                        if (res.data.code == 1) {
                            this.isiconfontshow = false;
                            this.alertTitleIshow = true;
                            setTimeout(() => {
                                this.alertTitleIshow = false;
                            }, 2000);
                            this.selectChange([]);
                            this.selectUploadedFeeItemList(1);
                        } else {
                            this.isiconfontshow = false;
                            this.alertTitle = res.data.msg;
                            this.alertTitleIshow2 = true;
                            setTimeout(() => {
                                this.alertTitleIshow2 = false;
                            }, 2000);
                        }
                    });
                } else {
                    this.errors = true;
                }
            },
            getSelectd(list) {
                //子组件接受选中套餐
                this.addSelectd = list;
            },
            piliang() {
                //批量修改
                if (this.selectNum > 0) {
                    this.modify = true;
                    this.selectedNum = this.selectNum;
                    this.list = this.selectList;
                } else {
                    this.errors = true;
                }
            },
            changePeoplecurrent(num) {
                //换页
                this.current = num;
                this.selectChange([]);
                this.selectUploadedFeeItemList();
            },
            ok() {
                this.errors = false;
            },
            selectUploadedFeeItemList(index) {
                //列表
                this.isiconfontshow = true;
                if (index) {
                    this.current = 1;
                }
                let params = {
                    name: this.name,
                    orderField: this.orderField,
                    isAsc: this.isAsc,
                    pageNum: this.current,
                    pageSize: this.pageSize
                };
                selectUploadedFeeItemList(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.obj = res.data.data;
                        this.data = res.data.data.list;
                        this.selectChange([]);
                    }
                });
            },
            chengeTable(item) {
                //点击修改
                this.list = [];
                this.selectedNum = 1;
                this.list.push(item);
                this.xiugai.select = item.canAddState + "";
                this.xiugai.special = item.specialItem + "";
                this.modify = true;
            },
            tonewAdd() {
                //点击新增
                this.xiugai.select = "1";
                this.$refs.Canadd.selectNewFeeItemList(1);
                this.addShow = true;
            },
            changepeoplepage(num) {
                //换每页请求多少条
                this.selectList = [];
                this.selectNum = this.selectList.length;
                this.pageSize = num;
                this.selectUploadedFeeItemList(1);
            },
            changesort(item) {
                //筛选
                this.orderField = item.key;
                this.isAsc = item.order;
                this.current = 1;
                if (item.order == "normal") {
                    this.isAsc = "";
                    this.orderField = "";
                }
                this.selectUploadedFeeItemList();
            },
            selectChange(item) {
                //表格select选中
                this.selectList = item;
                this.selectNum = this.selectList.length;
            },
            clear(index) {
                //取消 确定
                if (index == 1) {
                    this.modify = false;
                    this.addShow = false;
                    return;
                } else if (index == 2) {
                    //新增确定
                    this.addFeeItem();
                } else {
                    // 修改确定
                    this.updateFeeItemCanState();
                }
            },
            addFeeItem() {
                this.isiconfontshow = true;
                let list = [];
                if (this.addSelectd.length == 0) {
                    this.isiconfontshow = false;
                    this.addShow = false;
                    return;
                }
                for (let i = 0; i < this.addSelectd.length; i++) {
                    list.push(this.addSelectd[i].idExamFeeItem);
                }
                let params = {
                    idList: list.join(",")
                };
                addFeeItem(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.selectChange([]);
                        this.selectUploadedFeeItemList();
                        this.addShow = false;
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            updateFeeItemCanState() {
                //修改
                this.isiconfontshow = true;
                // this.isiconfontshow = true;
                let joinList = [];
                for (let i = 0; i < this.list.length; i++) {
                    joinList.push(this.list[i].id);
                }
                let params = {
                    idList: joinList.join(","),
                    canState: this.xiugai.select,
                    specialItem: this.xiugai.special
                };
                updateFeeItemCanState(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                        let idListArr=params.idList.split(",")
                        for(var i in idListArr){
                            this.data.find(item=>item.id==idListArr[i]).canAddState=params.canState;
                        }
                       
                        // this.selectUploadedFeeItemList();
                        this.modify = false;
                        //this.selectChange([]);
                       this.selectUploadedFeeItemList();
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            }
        },
        created() {
            this.selectUploadedFeeItemList();
        },
        components: {
            Canadd
        }
    };
</script>
<style lang="scss" scoped="" type="text/css">
    @import "../css/conmmon.scss";
    @import "../font/iconfont.css";
    .keyong {
        padding: 15px;
        font-size: 13px;
        height: 100%;
        width: 100%;
        overflow: hidden;
        overflow-y: scroll;
        overflow-y: visible;
        .top {
            width: calc(100% - 250px);
            height: 60px;
            line-height: 35px;
            position: fixed;
            top: 111px;
            z-index: 99;
            background: #fff;
            padding-top: 15px;
            left: 220px;
            padding-left: 15px;
            padding-bottom: 15px;
        }
        .select {
          width: 130px;
          margin-right: 10px;
        }
        .journal-input {
            width: 250px;
            vertical-align: top;
        }
        .title-btn {
           /*  width: 110px; */
            float: right;
            margin-left: 10px;
        }
        .title-btn2 {
          width: 110px;
          float: right;
          margin-left: 10px;
          line-height: 18px;
        }
        .table-cont {
            padding-top: 15px;
            margin: 40px 0 60px;
        }
        .page-div {
            width: 100%;
            margin-top: 15px;
            position: fixed;
            background: #fff;
            width: calc(100% - 270px);
            height: 60px;
            z-index: 99;
            bottom: 0;
            padding-top: 15px;
            .page-div-left {
                float: left;
                line-height: 30px;
            }
            .page-div-page {
                float: right;
                margin-right: 15px;
            }
            .title-btn {
                margin-left: 15px;
            }
        }
        .left {
            float: left;
            padding-right: 15px;
            border-right: 1px solid #d7d7d7;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/yuyue/canxiang.vue